import React, { memo } from 'react'
import styles from './HomeHeroSection.module.css'

const HomeHeroSection = () => {
  return (
    <div className={styles.main}>
      <video
        className={styles.video}
        /* Keep ?v=1. Once it's downloaded once, it will start 304-ing */
        // src={"https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/heroVideo.mp4?v=1"}
        src={"https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/hero/hero_1774440345747.mp4?v=1"}
        autoPlay
        muted
        loop
        playsInline
        /* Use 'auto' ONLY for the hero so it starts fast, but because 
           of memo, it only happens ONCE */
        preload="auto" 
      />
    </div>
  )
}

export default memo(HomeHeroSection);